<template>
    <div>
    <div class="customers-container" v-if="showCustomer === null">
      <b-container fluid>

        <b-row>
          <b-col cols="7">
            <customer-search @search="doSearch" :searchQuery='searchQuery'></customer-search>
          </b-col>
          <b-col class="d-flex justify-content-end">
            <b-button class="ml-auto mb-3" size="sm" @click="showCustomerDetails({})" variant="outline-dark">
              <b-icon-plus></b-icon-plus>
              <span class="ml-2 mr-1">New Customer</span>
            </b-button>
          </b-col>
        </b-row>
      </b-container>
  
      <div class="scrollable-container">
        <b-table
          primary-key="item"
          sticky-header
          small
          no-border-collapse
          class="customers-table"
          :items="provider"
          :fields="fields"
          :busy.sync="isBusy"
          ref="customersTable"
          id="customersTable"
          caption-top
        >
          <template #cell(customerId)="row">
            <copy-to-clipboard :value="row.value"></copy-to-clipboard>
            <b-button
              variant="link"
              @click="showCustomerDetails(row.item)"
            >
              {{ row.value }}
            </b-button>

          </template>
  
          <template #cell(email)="row">
            <a
              v-for="email in row.value"
              :key="email"
              class="cellListItem"
              :href="'mailto:' + email"
            >
              {{ email }}
            </a
            ><br />
          </template>
  
          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="mx-3">Loading...</strong>
            </div>
          </template>
        </b-table>
  

      </div>
    </div>
            <!-- Only show CustomerDetails when showCustomer is not null -->
            <customer-details v-if="showCustomer !== null" :customer="showCustomer" @closeCustomer="closeCustomer"></customer-details>
        </div>
  </template>

<script>
  import searchMixin from "../mixins/search";
  import inventoryApi from "../api/inventory";
  import ordersApi from "../api/orders";
  import customersApi from "../api/customers";
  import searchFilterNamesMixin from "../assets/searchFilterNames";
  import utils from "../mixins/utils";
  import CustomerSearch from "../components/customers/CustomerSearch";
  import CustomerDetails from "../components/customers/CustomerDetails";
  import CopyToClipboard from '../components/CopyToClipboard';

  export default {
      name: "Customers",
      components: { CustomerSearch, CustomerDetails, CopyToClipboard },
      mixins: [ searchMixin, inventoryApi, ordersApi, customersApi, utils, searchFilterNamesMixin ],
      props: [ 'outsideQuery' ],
      data() {
          return {
              searchResults: {},
              numCustomers: 0,
              currentPage: 1,
              perPage: 100,
              customers: [],
              selected: [],
              isBusy: false,
              searchQuery: {},
              fields: [
                  { key: 'customerId', label: 'Customer ID' },
                  { key: 'fullName', label: 'Name' },
                  { key: 'email', label: 'Email' },
                  { key: 'address[0].line1', label: 'Address'  },
              ],
              showCustomer: null,
          }
      },
      activated() {
          if (this.outsideQuery) {
              this.handleRoute();
          }
      },
      methods: {
          async provider(ctx) {
            try {
                  const searchObj = this.buildSearchObject(this.searchQuery);
                      if (ctx.sortBy && ctx.sortBy.length) {
                          searchObj.sort = ctx.sortBy;
                          searchObj.dir = ctx.sortDesc ? 'desc' : 'asc';
                      }
                      let results = await this.getCustomers(searchObj);
                      this.numCustomers = results.totalDocs;
                      this.searchResults = results;
                      return results;
              } catch (error) {
                  this.showError(error, 'Customer Search Error');
                  return [];
              }
          },
          async doSearch(search) {
            this.searchQuery = search;
            this.$refs.customersTable.refresh();
            },
          async handleRoute() {
            if (this.outsideQuery.customerId) {
                  if (!this.showCustomer || (this.showCustomer && this.showCustomer.customerId !== this.outsideQuery.customerId)) {
                      this.showCustomer = null;
                      this.doSearch({query: this.outsideQuery.customerId.toString()});
                  }

              }
          },
          showCustomerDetails(value) {
            this.showCustomer = value;
          },
          closeCustomer() {
            this.showCustomer = null;
          }
      },
      computed: {
      },
      watch: {
          outsideQuery(query) {
              if (query) {
                  this.handleRoute();
              }
          },
      }
  }
</script>

<style scoped>


  .customers-table {
      max-height: calc(100% - 10px);
      box-sizing: border-box;
  }

  .customers-container {
      display: flex;
      flex-direction: column;
      height: calc(100vh - 100px);
      box-sizing: border-box;    
  }

  .scrollable-container {
      overflow: auto;
      flex-grow: 1;
  }

  .cellListItem {
      width: max-content;
      padding-right: 10px;
  }


</style>